import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plan-check-circle",
  "use": "plan-check-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plan-check-circle\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#6998E4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M15 7.2v.657c-.002 3.163-2.042 5.949-5.015 6.846-2.973.897-6.17-.308-7.857-2.962a7.258 7.258 0 0 1 .55-8.529C4.694.808 8.019.042 10.85 1.33\" /><path d=\"M15 2.143l-7 7.15L5.9 7.15\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol